import { Component, AfterViewInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment'

@Component({
  selector: 'app-adsense-infeed',
  templateUrl: './adsense-infeed.component.html',
  styleUrls: ['./adsense-infeed.component.scss'],
})
export class AdsenseInfeedComponent implements AfterViewInit {

  constructor() { }
  @Input() adStyle?: string = ''

  /*인피드_텍스트 */
  @Input() adLayoutKey: string = '-gw-3+1f-3d+2z'
  @Input() adSlot: string = '7903773303'
  isProduction = environment.production

  ngAfterViewInit() {
    setTimeout(() => {
      try {
        (window['adsbygoogle'] = window['adsbygoogle'] || []).push({});
      } catch (e) {
        console.error("error");
      }
    }, 2000);
  }
}


